import { AmplitudeEvent } from './base-events';
import { FunnelEvent } from './funnel-event';
export class CategoryNavItemSelectEvent extends AmplitudeEvent {
  constructor(categoryId, categoryName, categoryType) {
    super();
    this.categoryId = categoryId;
    this.categoryName = categoryName;
    this.categoryType = categoryType;
    this.eventName = 'category_nav_item_select';
    this.category = 'navigation';
  }
  toEventProperties() {
    return {
      category_id: this.categoryId,
      category_name: this.categoryName,
      category_type: this.categoryType
    };
  }
}
export class AddToCartEvent extends FunnelEvent {
  constructor(productId) {
    super();
    this.eventName = 'add_to_cart_event';
    this.category = 'commerce';
    this.productId = productId;
  }
  toEventProperties() {
    return {
      product_id: this.productId,
      cart_contents: this.cartContents
    };
  }
}
//# sourceMappingURL=events.js.map